document.addEventListener("DOMContentLoaded", function () {
	const toggleButton = document.querySelector(".postal-code-button__toggle");
	const popupForm = document.querySelector(".postal-code-button__content");
	const inputField = document.querySelector(".postal-code-button__content__input");
	const submitButton = document.querySelector(".postal-code-button__content__submit");
	const etaValueElement = document.querySelector(".product__shipping-info__eta-value span");
	const errorMessage = document.querySelector(".postal-code-button__content__error");
	const deliveryDataInput = document.querySelector(".delivery-data");

	if (!toggleButton || !popupForm || !inputField || !submitButton || !etaValueElement || !deliveryDataInput) {
		return;
	}

	function getRegionFromPostalCode(postalCode) {
		const postalPrefix = postalCode.slice(0, 1).toUpperCase();
		const provinceMapping = {
			"V": "British Columbia",
			"T": "Alberta",
			"S": "Saskatchewan",
			"R": "Manitoba",
			"M": "Ontario",
			"K": "Ontario",
			"L": "Ontario",
			"H": "Quebec",
			"G": "Quebec",
			"B": "Nova Scotia",
			"C": "Prince Edward Island",
			"A": "Newfoundland and Labrador",
			"E": "New Brunswick",
			"Y": "Yukon",
			"X": "Northwest Territories",
			"X0": "Nunavut"
		};
		const province = provinceMapping[postalPrefix];
		if (!province) {
			return null;
		}
		const provinceRegions = {
			"Western Canada": ["British Columbia", "Alberta"],
			"Central Canada": ["Saskatchewan", "Manitoba"],
			"Eastern Canada": ["Ontario", "Quebec", "Newfoundland and Labrador", "Prince Edward Island", "Nova Scotia", "New Brunswick"],
			"Northern Canada": ["Yukon", "Nunavut", "Northwest Territories"]
		};
		for (const [region, provinces] of Object.entries(provinceRegions)) {
			if (provinces.includes(province)) return region;
		}
		return null;
	}

	const deliveryData = {
		"In Stock": parseDeliveryString(deliveryDataInput.dataset.deliveryStock || "")
	};
	console.log(deliveryData, "deliveryData")

	const savedPostalCode = localStorage.getItem("postalCode");
	if (savedPostalCode) {
		inputField.value = savedPostalCode;
		updateToggleButtonText(savedPostalCode);
		handleVariantChange();
	}
	toggleButton.addEventListener("click", () => {
		popupForm.classList.toggle("postal-code-button__content--open");
	});

	submitButton.addEventListener("click", async (event) => {
		event.preventDefault();
		const postalCode = inputField.value.trim();
		if (validatePostalCode(postalCode)) {
			hideError();
			localStorage.setItem("postalCode", postalCode);
			updateToggleButtonText(postalCode);
			handleVariantChange();
			updateCartDeliveryInfo();
			popupForm.classList.remove("postal-code-button__content--open");
		} else {
			showError("Please enter a valid Canadian postal code (e.g., V6A 4L5).");
		}
	});

	function validatePostalCode(postalCode) {
		const regex = /^[A-Z]\d[A-Z] \d[A-Z]\d$/i;
		return regex.test(postalCode);
	}

	function getDeliveryDateRange(postalCode, deliveryType) {
		const region = getRegionFromPostalCode(postalCode);
		if (!region || !deliveryType) {
			return null;
		}
		const deliveryInfo = deliveryData[deliveryType]?.[region];
		if (!deliveryInfo) {
			return null;
		}

		const now = new Date();
		const minDeliveryDate = new Date(now);
		minDeliveryDate.setDate(now.getDate() + deliveryInfo.minDays);
		const maxDeliveryDate = new Date(now);
		maxDeliveryDate.setDate(now.getDate() + deliveryInfo.maxDays);
		if (isNaN(minDeliveryDate.getTime()) || isNaN(maxDeliveryDate.getTime())) {
			return null;
		}

		if (deliveryType === "In Stock (Europe)" && window.variantMetaData){
			const variantId = getVariantId();
			const customDate = window.variantMetaData?.[variantId]?.custom_date;
			if (customDate) {
				return customDate;
			}
		}

		return formatDeliveryRange(minDeliveryDate, maxDeliveryDate);
	}

	function calculateDeliveryDate(postalCode, deliveryType) {
		const strings = window.theme.strings.deliveryDates;

		// Transit — статичний рядок по регіону
		if (deliveryType === "In Stock (Europe)") {
			const regionKey = postalCode ? getTransitRegionKey(postalCode) : null;
			etaValueElement.textContent =
				(regionKey && strings['delivery_date_transit_' + regionKey])
				|| strings.delivery_date_transit
				|| "Transit delivery";
			return;
		}

		// Pre Order — завжди один рядок
		if (deliveryType === "Pre Order") {
			const regionKey = postalCode ? getTransitRegionKey(postalCode) : null;
			etaValueElement.textContent =
				(regionKey && strings['delivery_date_preorder_' + regionKey])
				|| strings.delivery_date_preorder
				|| "Pre order delivery";
			return;
		}

		// In Stock — динамічна дата по днях
		const range = getDeliveryDateRange(postalCode, deliveryType);
		etaValueElement.textContent = range || "Delivery information unavailable.";
	}

	function getTransitRegionKey(postalCode) {
		const prefix = postalCode.slice(0, 1).toUpperCase();
		if (prefix === 'V') return 'west';
		if (prefix === 'T') return 'local';
		if (prefix === 'S' || prefix === 'R') return 'central';
		return 'east';
	}

	function handleVariantChange() {
  const postalCode = localStorage.getItem("postalCode") || "";
  const variantId = getVariantId();



  if (!variantId) {
    etaValueElement.textContent = "Delivery information unavailable. 1111";
    updateCartDeliveryInfo();
    return;
  }

		const deliveryType = window.variantMetaData?.[variantId]?.type;
  if (!deliveryType) {
    etaValueElement.textContent = "Delivery information unavailable. 2222";
    updateCartDeliveryInfo();
    return;
  }

  calculateDeliveryDate(postalCode, deliveryType);
  updateCartDeliveryInfo();
}

function getVariantId() {
  // 1) Пытаемся получить variant из URL
  const urlParams = new URLSearchParams(window.location.search);
  const urlVariant = urlParams.get("variant");
  if (urlVariant) return urlVariant;

  // 2) Если параметра нет — берём из <sundays-product-shipping-info data-var="...">
  //    или любого другого элемента, где хранится data-var
  const productShippingInfo = document.querySelector(".product__shipping-info");
  if (productShippingInfo) {
    return productShippingInfo.getAttribute("data-var");
  }

  // 3) Если и там нет — возвращаем null
  return null;
}


	function getVariantIdFromUrl() {
		const urlParams = new URLSearchParams(window.location.search);
		return urlParams.get("variant");
	}

	function parseDeliveryString(dataString) {
		const deliveryInfo = {};
		const lines = dataString.split(";").map(line => line.trim()).filter(line => line);
		lines.forEach((line) => {
			const splitIndex = line.indexOf("-");
			if (splitIndex === -1) {
				return;
			}
			const region = line.slice(0, splitIndex).trim();
			const days = line.slice(splitIndex + 1).replace("business days", "").trim();
			const daysRange = days.split("-").map(Number);
			if (daysRange.length === 2 && !isNaN(daysRange[0]) && !isNaN(daysRange[1])) {
				deliveryInfo[region] = { minDays: Math.min(daysRange[0], daysRange[1]), maxDays: Math.max(daysRange[0], daysRange[1]) };
			}
		});
		return deliveryInfo;
	}

	function formatDeliveryRange(minDate, maxDate) {
		if (isNaN(minDate.getTime()) || isNaN(maxDate.getTime())) {
			return "Invalid delivery range.";
		}
		const options = { month: "short", day: "numeric" };
		return `${minDate.toLocaleDateString("en-US", options)} - ${maxDate.toLocaleDateString("en-US", options)}`;
	}

	function updateToggleButtonText(postalCode) {
		const postalPrefix = postalCode.slice(0, 1).toUpperCase();
		const provinceMapping = {
			"V": "British Columbia",
			"T": "Alberta",
			"S": "Saskatchewan",
			"R": "Manitoba",
			"M": "Ontario",
			"K": "Ontario",
			"L": "Ontario",
			"H": "Quebec",
			"G": "Quebec",
			"B": "Nova Scotia",
			"C": "Prince Edward Island",
			"A": "Newfoundland and Labrador",
			"E": "New Brunswick",
			"Y": "Yukon",
			"X": "Northwest Territories",
			"X0": "Nunavut"
		};
		const province = provinceMapping[postalPrefix];
		toggleButton.textContent = province ? `${province}` : "Enter Postal Code";
	}

	function showError(message) {
		if (errorMessage) {
			errorMessage.textContent = message;
			errorMessage.style.display = "block";
		}
	}

	function hideError() {
		if (errorMessage) {
			errorMessage.style.display = "none";
		}
	}

	function updateCartDeliveryInfo() {
		const postalCode = localStorage.getItem("postalCode");
		const deliveryInfoElements = document.querySelectorAll('.delivery-info');
		deliveryInfoElements.forEach((el) => {
			const variantId = el.getAttribute('data-var');
			const span = el.querySelector('span');
			if (!postalCode || !variantId || !window.variantMetaData?.[variantId].type) {
				// span.textContent = "Delivery information unavailable.";
				return;
			}
			const deliveryType = window.variantMetaData[variantId].type;
			const customDate = window.variantMetaData[variantId].custom_date;

			if (deliveryType === "Pre Order") {
				const regionKey = postalCode ? getTransitRegionKey(postalCode) : null;
				const strings = window.theme.strings.deliveryDates;
				span.textContent =
					(regionKey && strings['delivery_date_preorder_' + regionKey])
					|| strings.delivery_date_preorder
					|| "Pre order delivery";
				return;
			}
			const range = getDeliveryDateRange(postalCode, deliveryType);
			if (range) {
				span.textContent = range;
			} else {
				// span.textContent = "Delivery information unavailable.";
			}
		});
	}

	window.addEventListener("popstate", handleVariantChange);

	(function (history) {
		const pushState = history.pushState;
		const replaceState = history.replaceState;
		history.pushState = function (...args) {
			pushState.apply(history, args);
			handleVariantChange();
		};
		history.replaceState = function (...args) {
			replaceState.apply(history, args);
			handleVariantChange();
		};
	})(window.history);

	handleVariantChange();
});
